import { Component } from "@angular/core";

@Component({
    selector: "web-notification-shimmer",
    templateUrl: "./notification-shimmer.component.html",
    styleUrls: ["./notification-shimmer.component.scss"],
})
export class NotificationShimmerComponent {}
